import React from 'react'
import { Link } from 'react-router-dom'
import styles from '../../sass/components/Products/CarouselContent.module.scss'


const CarouselContent = () => {
  return (
    <div className={styles.content}>
      <h2>Lorem ipsum dolor sit</h2>
      <p>
        Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad
      </p>
      <Link to="/">BUY NOW</Link>
      
    </div>
  )
}

export default CarouselContent
